import script from "./FreeToursView.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeToursView.vue?vue&type=script&setup=true&lang=js"

import "./FreeToursView.vue?vue&type=style&index=0&id=26c268e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c268e5"]])

export default __exports__